/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  PresenterAgentLoginSessionRequest,
  PresenterCurrentUser,
  PresenterMFIDSessionRequest,
  PresenterMFIDSessionResponse,
  PresenterOneOfficeResponse,
  PresenterResponse,
  PresenterSSOSessionRequest,
  PresenterUserInfo,
  PresenterWithdrawableStatus,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Sessions<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * @description MFID calls this endpoint after a user sign out
   *
   * @tags sessions
   * @name PostBackchannelLogout
   * @summary BackChannelLogout
   * @request POST:/backchannel_logout
   */
  postBackchannelLogout = (
    data: {
      /** userID to revoke all of session */
      user_id: number;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/backchannel_logout`,
      method: "POST",
      body: data,
      type: ContentType.UrlEncoded,
      ...params,
    });
  /**
   * @description return current office
   *
   * @tags sessions
   * @name GetCurrentOffice
   * @summary CurrentOffice
   * @request GET:/current_office
   */
  getCurrentOffice = (params: RequestParams = {}) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterOneOfficeResponse;
      },
      any
    >({
      path: `/current_office`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description return current user
   *
   * @tags sessions
   * @name GetCurrentUser
   * @summary CurrentUser
   * @request GET:/current_user
   */
  getCurrentUser = (params: RequestParams = {}) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterCurrentUser;
      },
      any
    >({
      path: `/current_user`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Navis calls this endpoint when suspending a tenant user to force logout
   *
   * @tags sessions
   * @name PostInternalTenantsByTenantUidTenantUsersByTenantUserUidBackchannelLogout
   * @summary Backchannel Logout for Tenant User
   * @request POST:/internal/tenants/{tenant_uid}/tenant_users/{tenant_user_uid}/backchannel_logout
   */
  postInternalTenantsByTenantUidTenantUsersByTenantUserUidBackchannelLogout = (
    tenantUid: number,
    tenantUserUid: number,
    params: RequestParams = {},
  ) =>
    this.http.request<string, string>({
      path: `/internal/tenants/${tenantUid}/tenant_users/${tenantUserUid}/backchannel_logout`,
      method: "POST",
      format: "json",
      ...params,
    });
  /**
   * @description return user info
   *
   * @tags sessions
   * @name GetMe
   * @summary UserInfo
   * @request GET:/me
   */
  getMe = (params: RequestParams = {}) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterUserInfo;
      },
      any
    >({
      path: `/me`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description return current office
   *
   * @tags sessions
   * @name GetOfficeGet
   * @summary CurrentOffice
   * @request GET:/office/get
   */
  getOfficeGet = (params: RequestParams = {}) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterOneOfficeResponse;
      },
      any
    >({
      path: `/office/get`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Create session from OAuth Code, nonce, tenant_uid for Replay Attacks
   *
   * @tags sessions
   * @name PostSessionsAgentlogin
   * @summary Create session with customer support user, delegated user
   * @request POST:/sessions/agentlogin
   */
  postSessionsAgentlogin = (
    body: PresenterAgentLoginSessionRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterMFIDSessionResponse;
      },
      any
    >({
      path: `/sessions/agentlogin`,
      method: "POST",
      body: body,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Create session from OAuth Code, nonce for Replay Attacks
   *
   * @tags sessions
   * @name PostSessionsMfid
   * @summary Create session with  MFID
   * @request POST:/sessions/mfid
   */
  postSessionsMfid = (
    body: PresenterMFIDSessionRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterMFIDSessionResponse;
      },
      any
    >({
      path: `/sessions/mfid`,
      method: "POST",
      body: body,
      type: ContentType.UrlEncoded,
      format: "json",
      ...params,
    });
  /**
   * @description Revoke User's Access Token and Refresh Token
   *
   * @tags sessions
   * @name DeleteSessionsMfid
   * @summary Revoke User's Access Token and Refresh Token
   * @request DELETE:/sessions/mfid
   */
  deleteSessionsMfid = (params: RequestParams = {}) =>
    this.http.request<PresenterResponse, any>({
      path: `/sessions/mfid`,
      method: "DELETE",
      format: "json",
      ...params,
    });
  /**
   * @description Refresh JWT from refresh token in Cookie
   *
   * @tags sessions
   * @name PostSessionsRefresh
   * @summary Refresh JWT
   * @request POST:/sessions/refresh
   */
  postSessionsRefresh = (params: RequestParams = {}) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterMFIDSessionResponse;
      },
      any
    >({
      path: `/sessions/refresh`,
      method: "POST",
      format: "json",
      ...params,
    });
  /**
   * @description Create session from OAuth Code, nonce, tenant_uid for Replay Attacks
   *
   * @tags sessions
   * @name PostSessionsSso
   * @summary Create session with  MFID and office_id
   * @request POST:/sessions/sso
   */
  postSessionsSso = (
    body: PresenterSSOSessionRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterMFIDSessionResponse;
      },
      any
    >({
      path: `/sessions/sso`,
      method: "POST",
      body: body,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description MFID calls this endpoint to check whether user can withdraw
   *
   * @tags sessions
   * @name GetWithdrawable
   * @summary WithdrawableStatus
   * @request GET:/withdrawable
   */
  getWithdrawable = (
    query?: {
      /** required */
      user_id?: string;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<PresenterWithdrawableStatus, any>({
      path: `/withdrawable`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
}
